<img (click)="like()" class="rate-icon" src="/assets/thumb-up.png" alt="like" *ngIf="!liked" />
<img (click)="like()" class="rate-icon" src="/assets/thumb-up-clicked.png" alt="liked" *ngIf="liked" />
<span (click)="like()" class="rate-count-like">{{likes}}</span>
<img (click)="dislike()" class="rate-icon" src="/assets/thumb-down.png" alt="dislike" *ngIf="!disliked" />
<img (click)="dislike()" class="rate-icon" src="/assets/thumb-down-clicked.png" alt="disliked" *ngIf="disliked" />
<span (click)="dislike()" class="rate-count-dislike">{{dislikes}}</span>